import { formatCurrencyInt } from '@edge/spark/utils'
import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const avgSaleAmount = ({ avgSaleAmount: _avgSaleAmount }: VehicleStatsByCompany): string =>
    _avgSaleAmount ? formatCurrencyInt(_avgSaleAmount) || '--' : '--'
